<template>
  <section>
    <!-- <el-dialog :visible.sync="dialogVisible_approve">
      <Approve v-if="dialogVisible_approve" @approve_submit="approve_submit" :SP_IF="SP_IF" :ApproveList="request_list"></Approve>
    </el-dialog> -->
    <el-form class="form_cls" :inline="true" :model="filters" @submit.native.prevent>
      <div style="display: flex; justify-content: space-between; width: 100%; margin-bottom: 10px">
        <span>达成率汇总</span>
        <!-- <div v-if="sionsummary_list.approvalStatus >= 0">
          审批状态：
          <span style="color: #6170d7; font-size: 12px">
            {{
              sionsummary_list.approvalStatus == 1
                ? '待审批'
                : sionsummary_list.approvalStatus == 2
                ? '审核通过'
                : sionsummary_list.approvalStatus == 3
                ? '审核未通过'
                : sionsummary_list.approvalStatus == 0
                ? '待上报'
                : ''
            }}
          </span>
        </div> -->
      </div>
      <div style="margin-left: 5px; margin-bottom: 10px">
        <div style="font-size: 12px; margin-bottom: 0px">
          <span>YTD{{ now_Month }}月-片数/达成：</span>
          <span
            :class="sionsummary_list.ytdNumberSum != sionsummary_old_list.ytdNumberSum && sionsummary_old_list.ytdNumberSum != null ? 'reds' : ''"
          >
            {{ currency(achievements_list.ytdNumberSum) }} / {{ (Number(achievements_list.ytdNumberAchieved) * 100).toFixed(0) }}%
          </span>
        </div>
        <div style="font-size: 12px; margin-bottom: 10px">
          <span>YTD{{ now_Month }}月-金额/达成：</span>
          <span
            :class="sionsummary_list.ytdAmountSum != sionsummary_old_list.ytdAmountSum && sionsummary_old_list.ytdNumberSum != null ? 'reds' : ''"
          >
            {{ currency(achievements_list.ytdAmountSum) }} / {{ (Number(achievements_list.ytdAmountAchieved) * 100).toFixed(0) }}%
          </span>
        </div>
      </div>
      <div style="font-size: 12px; color: red" v-if="sionsummary_list.message">驳回原因：{{ sionsummary_list.message }}</div>
      <div style="text-align: right; margin-bottom: 10px" v-if="sionsummary_list.approvalStatus == 1 || bh_if == 'bh'">
        <el-button v-if="sionsummary_list.approvalStatus != 2" style="margin-top: 5px" type="primary" @click.stop="submit_apply()">确认</el-button>
        <el-button v-if="sionsummary_list.approvalStatus != 2 || bh_if == 'bh'" style="margin-top: 5px" type="danger" @click.stop="reject_apply()">
          驳回
        </el-button>
      </div>
      <el-table
        border
        class="expends_cls2"
        max-height="100%"
        :data="achievements_list.achievements"
        :header-cell-style="{
          'text-align': 'center',
          color: '#6170d7',
          backgroundColor: '#F5F7FA',
          padding: ' 0px 0 !important',
          fontSize: '10px',
        }"
        :cell-style="{ 'text-align': 'center' }"
        highlight-current-row
        header-cell-class-name="header_cell_name"
        @current-change="selectCurrentRow"
        v-loading="listLoading"
        @selection-change="selsChange"
        :style="isMobile ? 'width:100%' : 'width:500px'"
      >
        <el-table-column prop="categoryName" label="品类" width="65">
          <template slot-scope="scope">
            <span style="font-size: 10px">{{ scope.row.categoryName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="categoryName" :label="now_Month + '月'">
          <el-table-column prop="ytdPieceAchieved" label="片数/达成" width="58">
            <template slot-scope="scope">
              <span :class="scope.row.red_if ? 'reds' : ''" style="font-size: 11px">
                {{ currency(scope.row.number1) + '/' + toFixeds2(scope.row.achieve1) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="ytdPieceAchieved" label="金额/达成" width="">
            <template slot-scope="scope">
              <span :class="scope.row.red_if ? 'reds' : ''" style="font-size: 11px">
                {{ currency(scope.row.numberPrice1) + '/' + toFixeds2(scope.row.achievePrice1) }}
              </span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column prop="categoryName" :label="next_Month + '月'">
          <el-table-column prop="ytdPieceAchieved" label="片数/达成" width="58">
            <template slot-scope="scope">
              <span :class="scope.row.red_if ? 'reds' : ''" style="font-size: 11px">
                {{ currency(scope.row.number2) + '/' + toFixeds2(scope.row.achieve2) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="ytdPieceAchieved" label="金额/达成" width="">
            <template slot-scope="scope">
              <span :class="scope.row.red_if ? 'reds' : ''" style="font-size: 11px">
                {{ currency(scope.row.numberPrice2) + '/' + toFixeds2(scope.row.achievePrice2) }}
              </span>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <div>
        <el-button v-if="old_but_if" style="margin-top: 10px" type="primary" size="mini" @click="tab_old">
          {{ old_if ? '查看审核数据' : '查看原数据' }}
        </el-button>
      </div>
      <br />
      <el-collapse v-if="currentuserrole == '产品线负责人' || currentuserrole == 'Leaders'" class="">
        <el-collapse-item title="查看小区" name="1">
          <div v-for="(items, index) in sdapprovaldetails_list">
            <div style="margin: 10px 5px 2px">{{ items.name }}：</div>
            <el-table
              border
              class="expends_cls2"
              max-height="100%"
              :data="items.old_lssj ? items.oldData.achievements : items.neweData.achievements"
              :header-cell-style="{
                'text-align': 'center',
                color: '#6170d7',
                backgroundColor: '#F5F7FA',
                padding: ' 0px 0 !important',
                fontSize: '10px',
              }"
              :cell-style="{ 'text-align': 'center' }"
              highlight-current-row
              header-cell-class-name="header_cell_name"
              @current-change="selectCurrentRow"
              v-loading="listLoading"
              @selection-change="selsChange"
              :style="isMobile ? 'width:100%' : 'width:500px'"
            >
              <el-table-column prop="categoryName" label="品类" width="65">
                <template slot-scope="scope">
                  <span style="font-size: 10px">{{ scope.row.categoryName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="categoryName" :label="now_Month + '月'">
                <el-table-column prop="ytdPieceAchieved" label="片数/达成" width="58">
                  <template slot-scope="scope">
                    <span :class="scope.row.red_if ? 'reds' : ''" style="font-size: 11px">
                      {{ currency(scope.row.number1) + '/' + toFixeds2(scope.row.achieve1) }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="ytdPieceAchieved" label="金额/达成" width="">
                  <template slot-scope="scope">
                    <span :class="scope.row.red_if ? 'reds' : ''" style="font-size: 11px">
                      {{ currency(scope.row.numberPrice1) + '/' + toFixeds2(scope.row.achievePrice1) }}
                    </span>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column prop="categoryName" :label="next_Month + '月'">
                <el-table-column prop="ytdPieceAchieved" label="片数/达成" width="58">
                  <template slot-scope="scope">
                    <span :class="scope.row.red_if ? 'reds' : ''" style="font-size: 11px">
                      {{ currency(scope.row.number2) + '/' + toFixeds2(scope.row.achieve2) }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="ytdPieceAchieved" label="金额/达成" width="">
                  <template slot-scope="scope">
                    <span :class="scope.row.red_if ? 'reds' : ''" style="font-size: 11px">
                      {{ currency(scope.row.numberPrice2) + '/' + toFixeds2(scope.row.achievePrice2) }}
                    </span>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table>
            <el-button v-if="items.old_but_if" style="margin-top: 10px" type="primary" size="mini" @click="tab_old_xq(index)">
              {{ items.old_lssj ? '查看审核数据' : '查看原数据' }}
            </el-button>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <!-- <div></div> -->
  </section>
</template>

<script>
import util from '../../../util/date'
import { calculateSum, loadings } from '@/utils'
import {
  estimate_getlist,
  estimate_exportdata,
  estimate_submitestimate,
  estimate_getsubmissionsummary,
  estimate_getapprovaldetails,
  estimate_submissionsummary,
  estimate_approvesubordinatereport,
  estimate_getsdapprovaldetails,
} from '../../api/api'
import { getButtonList } from '../../promissionRouter'
import { uploadfiles } from '@/uploadfiles'
import { quillEditor } from 'vue-quill-editor'
import EstimateListMobile from './mobile/EstimateListMobile'
import Toolbar from '../../components/Toolbar'
import Approve from '../../components/Approve'

export default {
  components: { Toolbar, quillEditor, Approve, EstimateListMobile },
  data() {
    return {
      currnrtTime: '',
      currentuserrole: '',
      sdapprovaldetails_list: [],
      bh_if: '',
      old_but_if: false,
      achievements_list: {},
      old_if: false,
      sionsummary_old_list: {},
      now_Month: '',
      collapses_val: [0],
      sionsummary_list: {},
      next_Month: '',
      today_if: 0,
      upload_from: {},
      dialogVisible_approve: false,
      dialogVisible_upload: false,
      SP_IF: '',
      isMobile: false,
      request_list: [],
      description_text: '',
      rolename_if: false,
      num_zt: 0,
      tableHeight: 0,
      buttonList: [],
      editorOption: {
        // editorOption里是放图片上传配置参数用的，例如：
        action: '/images/Upload/Pic', // 必填参数 图片上传地址
        methods: 'post', // 必填参数 图片上传方式
        token: this.token, // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
        // name: 'upload_file',  // 必填参数 文件的参数名
        // size: 500,  // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
        // accept: 'multipart/form-data, image/png, image/gif, image/jpeg, image/bmp, image/x-icon,image/jpg'  // 可选 可上传的图片格式
      },
      token: '',
      addLoading: false,
      editFormRules: {
        html: [{ required: true, message: '请填写', trigger: 'blur' }],
        type: [{ required: true, message: '请填写', trigger: 'blur' }],
      },
      currentRow: null,
      filters: {
        pageSize: 200,
      },
      tabel_list: [],
      statusList: [
        { LinkUrl: '激活', value: true },
        { LinkUrl: '禁用', value: false },
      ],
      total: 0,
      pageNumber: 1,
      listLoading: false,
      sels: [], //列表选中列
    }
  },
  methods: {
    tab_old_xq(e) {
      var sdapprovaldetails_list = this.sdapprovaldetails_list
      if (sdapprovaldetails_list[e].old_lssj) {
        sdapprovaldetails_list[e].old_lssj = false
      } else {
        sdapprovaldetails_list[e].old_lssj = true
      }
      this.sdapprovaldetails_list = [...sdapprovaldetails_list]
    },
    tab_old() {
      if (this.old_if) {
        this.achievements_list = this.sionsummary_list
        this.old_if = false
      } else {
        if (!this.sionsummary_old_list) {
          this.$alert('暂无原数据', '提示', {})
          return
        }
        this.achievements_list = this.sionsummary_old_list
        this.old_if = true
      }
    },
    back_url() {
      this.$router.go(-1)
    },
    async estimate_approvesubordinatereport_fn(isApproved, message) {
      const { data } = await estimate_approvesubordinatereport({ recordId: this.$route.query.id, isApproved: isApproved, message: message })
      if (data.code == 200) {
        this.$message({
          message: data.msg,
          type: 'success',
        })
        this.back_url()
      } else {
        this.$message({
          message: data.msg,
          type: 'error',
        })
      }
    },
    reject_apply(e) {
      this.$prompt('请输入驳回理由', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^.+$/,
        inputErrorMessage: '驳回理由不能为空',
      }).then(async ({ value }) => {
        this.estimate_approvesubordinatereport_fn(false, value)
      })
    },
    submit_apply(e) {
      this.$confirm('确定同意？', '提示', {
        type: 'warning',
      }).then(async () => {
        this.estimate_approvesubordinatereport_fn(true, '')
      })
    },
    currency(val) {
      if (val == '' || val == null) {
        return val
      }
      if (Number(val) == 0) {
        return 0
      }
      let precision = 0
      let decimal = this.checkNaN(val, (v) => v.toFixed(precision))
      const [n, d = []] = decimal.toString().split('.')
      return [n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')].concat(d).join('.')
      //   }
    },
    checkNaN(value, cb) {
      const val = parseFloat(value)
      return isNaN(val) ? undefined : cb(val)
    },
    toFixeds2(cellValue) {
      if (cellValue == 'Infinity%' || cellValue == null || cellValue == 0) {
        return '0%'
      } else {
        return (cellValue * 100).toFixed(0) + '%'
      }
    },
    toFixeds(cellValue) {
      if (cellValue == 'Infinity%' || cellValue == null || cellValue == 0) {
        return '0%'
      } else {
        return (cellValue * 100).toFixed(2) + '%'
      }
    },
    async ExportAccount() {
      this.dialogVisible_upload = true
    },
    open_approve(res) {
      this.request_list = res
      this.dialogVisible_approve = true
      console.log(this.request_list)
    },
    async approve_submit(res) {
      if (res.CH_IF) {
        var { data } = await cataractnnvmp_approvalcancel(res)
      } else {
        var { data } = await cataractnnvmp_approvalclaim(res)
      }
      if (data.code == 200) {
        this.$message.success(data.msg)
      } else {
        this.$message.error(data.msg)
      }
    },
    selectCurrentRow(val) {
      this.currentRow = val
    },
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    handleCurrentChange(val) {
      this.pageNumber = val
      this.getModules()
    },
    getModules_search() {
      this.pageNumber = 1
      this.getModules()
    },
    //获取用户列表
    getModules() {
      let para = this.filters
      para.pageNumber = this.pageNumber
      console.log(para)
      this.listLoading = true
      estimate_getlist(para).then((res) => {
        this.total = res.data.data.dataCount
        this.tabel_list = res.data.data.data
        this.listLoading = false
        this.SP_IF = this.$route.query.status
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
    async estimate_getsubmissionsummary_fn() {
      const { data } = await estimate_getapprovaldetails({
        key: this.$route.query.name,
        currnrtTime: this.currnrtTime,
      })
      var neweData = data.data.neweData
      var oldData = data.data.oldData
      if (data.data.oldData) {
        for (let s in oldData.achievements) {
          for (let i in oldData.achievements[s]) {
            if (oldData.achievements[s][i] != neweData.achievements[s][i]) {
              oldData.achievements[s].red_if = true
              neweData.achievements[s].red_if = true
            }
          }
        }
        this.old_but_if = true
      }
      this.sionsummary_list = neweData
      this.achievements_list = neweData
      this.sionsummary_old_list = oldData ? oldData : {}
    },
    async estimate_getsdapprovaldetails_fn() {
      const { data } = await estimate_getsdapprovaldetails({ key: this.$route.query.name, currnrtTime: this.currnrtTime })
      var listsdappr = data.data
      for (var t in listsdappr) {
        let oldData = listsdappr[t].oldData
        let neweData = listsdappr[t].neweData
        if (oldData) {
          for (let s in oldData.achievements) {
            for (let i in oldData.achievements[s]) {
              if (oldData.achievements[s][i] != neweData.achievements[s][i]) {
                oldData.achievements[s].red_if = true
                neweData.achievements[s].red_if = true
              }
            }
          }
          listsdappr[t].old_but_if = true
        }
      }
      this.sdapprovaldetails_list = listsdappr
    },
  },
  mounted() {
    const now = new Date()
    const currentMonth = now.getMonth() + 1
    const nextMonth = now.getMonth() + 1 + 1
    this.currentuserrole = this.$route.query.currentuserrole

    this.bh_if = this.$route.query.bh_if
    this.now_Month = currentMonth
    if (nextMonth > 12) {
      this.next_Month = 1
    } else {
      this.next_Month = nextMonth
    }
    if (window.innerWidth <= 767) {
      this.isMobile = true
      this.collapsedClass = 'menu-collapsed'
      //   this.SidebarVisible = false
    }
    if (this.bh_if == 'last_month') {
      this.now_Month = calculateSum(8)
      this.next_Month = calculateSum(9)
      this.currnrtTime = calculateSum(7)
    }
    if (this.currentuserrole == '产品线负责人' || this.currentuserrole == 'Leaders') {
      this.estimate_getsdapprovaldetails_fn()
    }
    const date = new Date()
    const today = date.getDate()
    if (today > 19 && today < 24) {
      this.today_if = 2
    }
    this.estimate_getsubmissionsummary_fn()
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - 250
    })
    // this.getModules()
    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }

    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
    console.log(this.buttonList)
  },
}
</script>

<style scoped>
.reds {
  color: red;
}
</style>
<style>
.expends_cls2 .cell {
  padding: 0 5px !important;
}
.expends_cls2 td.el-table__cell {
  padding: 1px 0 !important;
}
.collapsessss > .el-collapse-item > div:nth-child(1) {
  height: 40px !important;
}
</style>
